import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../../shared/providers/base-provider';
import { PopupInteractionNotifier } from './popup-interaction-notifier';
import { PopupInteractionState } from './popup-interaction-state';

@Injectable()
export class PopupInteractionProvider extends BaseProvider<PopupInteractionNotifier, PopupInteractionState> {
  constructor() {
    super(PopupInteractionNotifier);
  }
}
